import { FilterOption, FilterValue } from './types';

export const optionToValue = (opt: FilterOption): FilterValue => ({
  value: opt.value,
  title: opt.stringTitle || (typeof opt.title === 'string' ? opt.title : '') || opt.value,
});
